export const CompanyRouting = [
  {
    path: "/cooperation/company/list",
    name: "basic-cooperation-company-list",
    meta: { title: "往来单位管理" },
    component: () =>
      import(
        /* webpackChunkName: "basic-cooperation-company" */ "@/views/cooperation/company/list/index.vue"
      ),
  },
   {
    path: "/cooperation/company/list/customer",
    name: "basic-cooperation-company-list-customer",
    meta: { title: "客户单位",type:2 },
    component: () =>
      import(
        /* webpackChunkName: "basic-cooperation-company" */ "@/views/cooperation/company/list/index.vue"
      ),
  },
   {
    path: "/cooperation/company/list/vendor",
    name: "basic-cooperation-company-vendor",
    meta: { title: "供应商单位",type:1 },
    component: () =>
      import(
        /* webpackChunkName: "basic-cooperation-company" */ "@/views/cooperation/company/list/index.vue"
      ),
  },
   {
    path: "/cooperation/company/list/interior",
    name: "basic-cooperation-company-list-interior",
    meta: { title: "内部单位",type:3 },
    component: () =>
      import(
        /* webpackChunkName: "basic-cooperation-company" */ "@/views/cooperation/company/list/index.vue"
      ),
  },
   {
    path: "/cooperation/company/list/exterior",
    name: "basic-cooperation-company-list-exterior",
    meta: { title: "其他单位",type:4 },
    component: () =>
      import(
        /* webpackChunkName: "basic-cooperation-company" */ "@/views/cooperation/company/list/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/cooperation/company/create",
    name: "basic-cooperation-company-create",
    meta: { title: "新增单位" },
    component: () =>
      import(
        /* webpackChunkName: "basic-cooperation-company" */ "@/views/cooperation/company/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/cooperation/company/edit/:id",
    name: "basic-cooperation-company-edit",
    meta: { title: "编辑单位" },
    component: () =>
      import(
        /* webpackChunkName: "basic-cooperation-company" */ "@/views/cooperation/company/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/cooperation/company/detail/:id",
    name: "basic-cooperation-company-detail",
    meta: { title: "单位详情" },
    component: () =>
      import(
        /* webpackChunkName: "basic-cooperation-company" */ "@/views/cooperation/company/form-detail/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/cooperation/company/flowPrint/:id",
    name: "basic-cooperation-company-flowPrint",
    meta: { title: "单位详情" },
    component: () =>
      import(
        /* webpackChunkName: "basic-cooperation-company" */ "@/views/cooperation/company/flow-print/index.vue"
        ),
  },
];
